import styled, { css } from 'styled-components';

export const Container = styled.div`
   position: relative;
   display: flex;
   flex-direction: column;
   padding: 0.3rem;
   border-radius: 10px;
   box-shadow: 0 1px 1px #ccc;
   background-color: ${({ isUserSystem }) => isUserSystem ? ' #E7F8FF' : '#ffffff'};
   user-select: none;

   .skeletonPlayerAudio{
      display: flex;
      width: 360px;
      padding: 0.5rem;
      align-items: center;
      flex-direction: column;
      border-radius: 10px;
      box-shadow: 0 1px 1px #ccc;
      .line--{
         display: flex;
         flex-direction: row;
         align-items: center;
         gap: 0.5rem;
      }
      .icon--{
         font-size: 2.5rem;
         color: #e9ecef; 
      }
      .skeleton--progress{
         position: relative;
         display: flex;
         width: 240px;
         height: 6px;
         border-radius: 10px;
         background-color: #e9ecef;
      }
      .skeleton--progress--::before{
         position: absolute;
         top: 0;
         left: 0;
         border-radius: 10px;
         content: "";
         height: 100%;
         width: 100%;
         background-color: #e9ecef;
         background-image: linear-gradient(to right, #e9ecef 0%, rgba(0,0,0,0.05) 20%, #e9ecef 40%, #e9ecef 100%);
         background-repeat: no-repeat;
         background-size: 450px 400px;
         animation: shimmer 2s linear infinite;
      }
      .skeleton--avat{
         position: relative;
         width: 60px;
         height: 60px;
         border-radius: 50%;
         background-color: #e9ecef; 
      }
      .skeleton--avat--::before{
         position: absolute;
         top: 0;
         left: 0;
         border-radius: 50%;
         content: "";
         height: 100%;
         width: 100%;
         background-color: #e9ecef;
         background-image: linear-gradient(to right, #e9ecef 0%, rgba(0,0,0,0.05) 20%, #e9ecef 40%, #e9ecef 100%);
         background-repeat: no-repeat;
         background-size: 450px 400px;
         animation: shimmer 2s linear infinite;
      }  
   }

   .skeletonTranscription{
      display: flex;
      padding: 0.3rem;
      flex-direction: column;
      gap: 0.3rem;
      margin-top: 0.5rem;
      .skeleton--line-1{
         position: relative;
         width: 100%;
         height: 15px;
         border-radius: 4px;
         background-color: #e9ecef;
      }
      .skeleton--line-2{
         position: relative;
         width: 80%;
         height: 15px;
         border-radius: 4px;
         background-color: #e9ecef;
      }
      .skeleton--line-3{
         position: relative;
         width: 50%;
         height: 15px;
         border-radius: 4px;
         background-color: #e9ecef;
      }
      .skeleton--line--::before{
         position: absolute;
         top: 0;
         left: 0;
         border-radius: 4px;
         content: "";
         height: 100%;
         width: 100%;
         background-color: #e9ecef;
         background-image: linear-gradient(to right, #e9ecef 0%, rgba(0,0,0,0.05) 20%, #e9ecef 40%, #e9ecef 100%);
         background-repeat: no-repeat;
         background-size: 450px 400px;
         animation: shimmer 2s linear infinite;
      }  
   }
   
   .flex-end{
      align-items: end;
   }

   @keyframes shimmer {
      0%{
         background-position: -450px 0;
      }
      100%{
         background-position: 450px 0;
      }
   }

   .footer-styled{
      margin-top: 0.5rem;
      margin-right:5px;
      margin-left: 5px;
      ${({ isUserSystem }) =>
      !isUserSystem &&
      css`
            position: absolute;
            bottom: 6px;
            right: 10px;
         `
      }
   }
`
export const PlayerAudio = styled.div`
   display: flex;
   width: 360px;
   padding: 0.5rem;
   align-items: center;
   flex-direction: column;
   border-radius: 10px;
   box-shadow: 0 1px 1px #ccc;
   background:transparent;

   .line--{
      position: relative;
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 0.5rem;
   }
   .icon--{
      font-size: 2.5rem;
      color: #919191;
      cursor: pointer;
   }
   .icon--:hover{
      opacity: 0.9;
   }
   .progress--time{
      position: relative;
   }
   .progress--{
      position: relative;
      display: flex;
      width: 240px;
      height: 16px;
      cursor: pointer;
   }
   .time--{
      position: absolute;
      display: flex;
      top: 13px;
      left: 0px;
      width: 100%;
      padding: 5px 10px 0 10px;
      justify-content: space-between;
      color: #999;
      font-size: 11px;
   }
   .avatar{
      position: relative;
      width: 60px;
      height: 60px;
      border-radius: 50%;
      background-color: #e9ecef; 
      box-shadow: 0 0 3px rgba(0, 0, 0, 0.5);
   }
   .playbackRate{
      display: flex;
      width: 60px;
      height: 60px;
      justify-content: center;
      align-items: center;
      span{
         width: 100%;
         font-size: 1rem;
         font-weight: bolder;
         cursor: pointer;
         padding: 0.3rem;
         color: #ffffff;
         background-color: #dddcdc;
         border-radius:6px; 
      }
      .color--UserSystem{
         background-color: #b3dae9;
      }
   }
   .mic-icon{
      position: absolute;
      bottom: 0px;
      right: -3px;
      font-size: 1.5rem;
      color: #595959;
   }
`
export const Transcription = styled.div`
   display: flex;
   padding: 0.3rem;
   margin-top: 0.5rem;
   text-align: left;
   max-width: 360px;
   p{
      padding: 2px;
      font-size: 14px;
      word-break: break-word;
      white-space: pre-wrap; 
      text-align: left;
   }
`